import Session from 'services/session/Session';
import api from './base/userExternalApi';

function withToken( params: any ) {
  return {
    ...params,
    Token: Session.getToken() || '',
  };
}

export default {
  getInvitation( params: { InvitacionUid:string } ) {
    return api.get( 'api/invitaciondescarga/VerificarInvitacion', withToken( params ) );
  },
  getInvitationCode( params: { InvitacionUid:string, CodigoControl:string } ) {
    return api.get( 'api/invitaciondescarga/VerificarCodigoControl', params );
  },
  postInvitationNda( body:any, params: { InvitacionUid:string } ) {
    return api.post( 'api/invitaciondescarga/SendNDAToSign', body, { params: withToken( params ) } );
  },
  postInvitationSimulacionNda(
    body:{ ndaUid:string, codigo:string },
    params: { InvitacionUid:string },
  ) {
    return api.post( 'api/invitaciondescarga/SimularFirmaNda', body, { params: withToken( params ) } );
  },
  validateInvitationEmail( params: { linkUuid: string, email: string } ) {
    return api.get( 'api/invitaciondescarga/ValidarLink', params );
  },
  getInvitationNdaStatus( params: { InvitacionUid:string, NdaUid:string } ) {
    return api.get( 'api/invitaciondescarga/GetEstadoFirmaNda', withToken( params ) );
  },
  getInvitationDocuemnts( params: { InvitacionUid:string } ) {
    return api.get( 'api/invitaciondescarga/GetDocumentsToDownload', withToken( params ) );
  },
  getInvitationDocuemntsAsync( params: { InvitacionUid:string } ) {
    return api.get( 'api/invitaciondescarga/GetDocumentsToDownloadV2', withToken( params ) );
  },

  postCompartirDocumentosOportunidad( body: { oportunidadId:any, email:string }, token: string ) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return api.post( 'api/invitaciondescarga/CompartirDocumentosOportunidad', body, config );
  },
  getInvitationDocuemntDownload( params: {
    InvitacionUid:string,
    DocumentoUid:string, TokenDescarga:string
  }, config?:any ) {
    return api.get( 'api/invitaciondescarga/DownloadDocument', withToken( params ), config );
  },
  startDownloadAll( params: { InvitacionUid: string } ) {
    return api.post( 'api/invitaciondescarga/StartDownloadAll', null, { params: withToken( params ) } );
  },
  getDownloadAllStatus( params: { InvitacionUid: string; DescargaId: string } ) {
    return api.get( 'api/invitaciondescarga/DownloadAllStatus', withToken( params ) );
  },
};
